import React from 'react';
import styled from 'styled-components';

import { Box } from 'Components/Base';

export const GridList = styled(Box)`
  display: grid;
  justify-items: center;
  gap: ${({ gap }) => (gap ? gap : '24px 15px')};
  grid-template-columns: ${({ minMaxWidth }) =>
    minMaxWidth
      ? `repeat(auto-fill, minmax(${minMaxWidth}, 1fr))`
      : `repeat(auto-fill, minmax(343px, 1fr))`};
`;
